module.exports = __webpack_public_path__ + "img/player.e904fb4d.png";